import { type Menu } from '@atlassian/conversation-assistant-store/controllers/ui-store';

/**
 * Whether the staging area (e.g. the Confluence copied-page / AIFC create flow)
 * should force the Rovo nav menu closed.
 *
 * The staging area wants the menu closed so its focused UI is shown, BUT
 * launching a space landing view repoints Rovo's context to the space and its
 * linked sources, so an active space landing must take precedence. Returning
 * `false` for `'space-landing'` prevents the space landing page (and its embedded
 * chat input) from being blanked — e.g. on sidebar → mini-modal, or when
 * launching a space empty state from the nav on a copied page.
 */
export const shouldCloseMenuForStagingArea = (
	stagingAreaEnabled: boolean | undefined,
	activeMenu: Menu,
): boolean => Boolean(stagingAreaEnabled) && activeMenu !== 'space-landing';
